import React from 'react';
import { Typography } from 'antd';
import {
  PRIMITIVE_AUTHORITY_FLAGS,
  type PrimitivePresentationState,
} from './primitiveSurfaceState';
import { PrimitiveSurfaceFrame } from './PrimitiveSurfaceFrame';
import styles from './primitives.module.css';

const { Text } = Typography;

export interface OperationTimelineEntryV0 {
  readonly id: string;
  readonly occurredAt: string;
  readonly label: string;
  readonly detail?: string | null;
  readonly receiptRef?: string | null;
}

export interface OperationTimelineProps {
  readonly presentationState: PrimitivePresentationState;
  readonly entries?: readonly OperationTimelineEntryV0[];
  readonly grantsAuthority?: false;
  readonly grantsApproval?: false;
  readonly 'data-testid'?: string;
}

export function OperationTimeline(props: OperationTimelineProps): React.ReactElement {
  const grantsAuthority = props.grantsAuthority ?? PRIMITIVE_AUTHORITY_FLAGS.grantsAuthority;
  const grantsApproval = props.grantsApproval ?? PRIMITIVE_AUTHORITY_FLAGS.grantsApproval;
  if (grantsAuthority !== false || grantsApproval !== false) {
    throw new Error('OperationTimeline must keep grantsAuthority/grantsApproval=false');
  }

  const entries = props.entries ?? [];

  return (
    <PrimitiveSurfaceFrame
      title="작업 타임라인"
      presentationState={props.presentationState}
      emptyMessage="타임라인 항목이 없습니다."
      data-testid={props['data-testid'] ?? 'operation-timeline'}
      aria-label="작업 타임라인"
    >
      {entries.length === 0 ? (
        <Text type="secondary">서버 이력이 없습니다.</Text>
      ) : (
        <ol className={styles.primitiveTimeline}>
          {entries.map((entry) => (
            <li key={entry.id} className={styles.primitiveTimelineItem}>
              <Text type="secondary">{entry.occurredAt}</Text>
              <Text strong>{entry.label}</Text>
              {entry.detail ? <Text>{entry.detail}</Text> : null}
              {entry.receiptRef ? <Text type="secondary">영수증: {entry.receiptRef}</Text> : null}
            </li>
          ))}
        </ol>
      )}
    </PrimitiveSurfaceFrame>
  );
}
